import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import button from 'react-rte/lib/ui/Button';
import { ExpandableText, TextToolTip } from 'components';
import { CustomDeleteModal } from 'fragments';
import { loadActions } from 'store';
import { Images, isAdmin, useModal } from 'utils';
import { AddReceivableNotes } from './addReceivableNotes';

const DELETE_ACTION_TYPE = 'DELETE_RECEIVABLES_NOTE';

export const ReceivableNoteCard = ({ item, searchValue }) => {
  const [showMoreInfo, setShowMoreInfo] = useState({
    customerInfo: false,
    loadsInfo: false,
  });
  const dispatch = useDispatch();

  const { open, close } = useModal();


  const slicedIViwCustomer = item?.customers?.slice(0, 3);
  const slicedIViwMoreCustomer = item?.customers?.slice(3);

  const slicedIViwLoad = item?.loads?.slice(0, 4);
  const slicedIViwMoreLoad = item?.loads?.slice(4);

  const handleEditNote = () => {
    open(<AddReceivableNotes item={item} searchValue={searchValue} />, { noPadding: true, noCloseButton: true });
  };

  const toggleShowMoreInfo = (path) => {
    setShowMoreInfo(prev => ({
      ...prev,
      [path]: !prev[path],
    }));
  };

  return (
    <div className='receivable-note-card-wrapper'>
      <div className='receivable-note-card-box'>
        <div className='receivable-note-card-main-info-box'>
          <div className='receivable-note-card-main-info-icon_note'>
            <div className='receivable-note-card-icon'>
              <TextToolTip
                text={<img src={Images.receivables} alt='receivable' />}
                content='Receivable Note'
                showTooltip
              />
            </div>

            {item?.note &&
              <ExpandableText htmlContent={item?.note} />
            }
          </div>

          <div className='receivable-note-card-main-info-actions'>
            {isAdmin &&
              <button className='reset-btn' onClick={handleEditNote}>
                <img src={Images.edit} alt='edit' />
              </button>
            }

            <button
              className='reset-btn'
              onClick={() => open(
                <CustomDeleteModal
                  afterSuccess={() => {
                    close();
                  }}
                  actionType={DELETE_ACTION_TYPE}
                  text='Delete note?'
                  info={'Note'}
                  handleDel={() => dispatch(loadActions.deleteRecNote(item?.id))}
                />,
              )}
            >
              <img src={Images.removeRed} alt='delete' />
            </button>
          </div>
        </div>

        <p className='receivable-note-card-main-info-dates'>
          <p className='receivable-note-card-main-info-text' style={{ whiteSpace: 'nowrap' }}>
            {moment.utc(item?.createdDate).format('MM/DD/YYYY')}
          </p>

          <p className='receivable-note-card-main-info-text' style={{ whiteSpace: 'nowrap' }}>
            {moment(item?.createdDate).format('LT')}
          </p>

          {item?.creator?.firstName &&
            <p className='receivable-note-card-main-info-text' style={{ whiteSpace: 'nowrap' }}>
              Created by:
            </p>
          }
          {item?.creator?.firstName &&
            <TextToolTip
              classNameText='receivable-note-card-main-info-text'
              text={`${item?.creator?.firstName} ${item?.creator?.lastName}`}
              content={`${item?.creator?.firstName} ${item?.creator?.lastName}`}
            />
          }
        </p>
      </div>

      <div className='receivable-note-card-box flex' style={{ gap: '4px', borderTop: '1px solid #E6ECF3' }}>
        {!!item?.customers?.length &&
          <div className='receivable-note-card-customers-wrapper'>
            <p className='receivable-note-card-customers_load-title'>Customers:</p>

            <div className='receivable-note-card-customers-box'>
              {slicedIViwCustomer?.map((customer, index) => (
                <div
                  className='receivable-note-card-customers-box-text-wrapper'
                  key={index}
                >
                  <TextToolTip
                    classNameText='receivable-note-card-customers-box-text'
                    wrapperStyles={{ width: 'fit-content' }}
                    text={customer?.name}
                    content={customer?.name}
                  />
                </div>
              ))}

              {(!!slicedIViwMoreCustomer?.length && showMoreInfo?.customerInfo) &&
                slicedIViwMoreCustomer?.map((customer, index) => (
                  <div
                    className='receivable-note-card-customers-box-text-wrapper'
                    key={index}
                  >
                    <TextToolTip
                      classNameText='receivable-note-card-customers-box-text'
                      wrapperStyles={{ width: 'fit-content' }}
                      text={customer?.name}
                      content={customer?.name}
                    />
                  </div>
                ))
              }

              {!!slicedIViwMoreCustomer?.length &&
                <button
                  className='receivable-note-card-view-more-btn'
                  onClick={() => toggleShowMoreInfo('customerInfo')}
                >
                  {showMoreInfo?.customerInfo ? 'View Less' : 'View More'}
                </button>
              }
            </div>
          </div>
        }

        {!!item?.loads?.length &&
          <div className='receivable-note-card-loads'>
            <p className='receivable-note-card-customers_load-title'>
              Loads:
            </p>
            <div className='receivable-note-card-loads-box'>
              {slicedIViwLoad?.map((customer, index) => (
                <div
                  key={index}
                  className='receivable-note-card-loads-box-text-wrapper'
                >
                  <TextToolTip
                    wrapperStyles={{ width: 'fit-content' }}
                    classNameText='receivable-note-card-loads-box-text'
                    text={customer?.displayId}
                    content={customer?.displayId}
                  />
                </div>
              ))}

              {(!!slicedIViwMoreLoad?.length && showMoreInfo?.loadsInfo) &&
                slicedIViwMoreLoad?.map((customer, index) => (
                  <div
                    key={index}
                    className='receivable-note-card-loads-box-text-wrapper'
                  >
                    <TextToolTip
                      wrapperStyles={{ width: 'fit-content' }}
                      classNameText='receivable-note-card-loads-box-text'
                      text={customer?.displayId}
                      content={customer?.displayId}
                    />
                  </div>
                ))}

              {!!slicedIViwMoreLoad?.length &&
                <button
                  className='receivable-note-card-view-more-btn view-more-customer'
                  onClick={() => toggleShowMoreInfo('loadsInfo')}
                >
                  {showMoreInfo?.loadsInfo ? 'View Less' : 'View More'}
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  );
};

